// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";
import ReviewShowTextContent from "@/components/ReviewShowTextContent";
import { IReviewItem } from "Models";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
const maxlen = 500;
const ReviewDetailTextContent = ({ data }: { data: IReviewItem }) => {
  const [showFull, setShowFull] = useState<number>(1);
  const {
    query: { comment },
  } = useRouter();
  // const rawText = useMemo(()=>{
  // })
  const rawTextContent = useMemo(() => {
    let rawContentString = data.comment;
    data.mentions?.forEach((mention) => {
      rawContentString = rawContentString
        .replaceAll(
          `@{{${mention.userId}||${mention.nickName}}}`,
          `@${mention.nickName}`
        )
        .replaceAll(`@{{${mention.userId}||anymos}}`, `@Ẩn danh`);
    });
    return rawContentString;
  }, [data]);

  return rawTextContent?.length ? (
    <div
      key={data._id}
      className="mt-2 text-fs-14 !whitespace-pre-line inline-block">
      {rawTextContent?.length > maxlen ? (
        showFull * maxlen >= rawTextContent?.length ? (
          <ReviewShowTextContent
            content={data.comment}
            mentions={data.mentions}
            limit={maxlen * showFull}
            searchString={comment as string}
          />
        ) : (
          <>
            <ReviewShowTextContent
              content={data.comment}
              mentions={data.mentions}
              searchString={comment as string}
              limit={maxlen * showFull}
            />
            {!comment ? (
              <>
                {"..."}{" "}
                <span
                  className="text-blue-500 cursor-pointer"
                  onClick={() => setShowFull(showFull + 1)}>
                  xem thêm
                </span>
              </>
            ) : null}
          </>
        )
      ) : (
        <ReviewShowTextContent
          content={data.comment}
          mentions={data.mentions}
          searchString={comment as string}
          limit={null}
        />
      )}
    </div>
  ) : null;
};

export default ReviewDetailTextContent;
